/**
 *
 * 字节跳动reLaunch方法
 * @export
 * @param {*} url
 */
export function ttRaLunch (url) {
  tt.miniProgram.reLaunch({
    url
  })
}

/**
 *
 * 字节跳动NavigateTo方法
 * @export
 * @param {*} url
 */
export function ttNavigateTo (url) {
  tt.miniProgram.navigateTo({
    url
 })
}

/**
 *
 * 字节跳动redirectTo方法
 * @export
 * @param {*} url
 */
export function ttRedirectTo (url) {
  tt.miniProgram.redirectTo({
    url
 })
}

/**
 *
 * 字节跳动SwitchTabTo方法
 * @export
 * @param {*} url
 */
export function ttSwitchTabTo (url) {
  tt.miniProgram.switchTab({
    url
  })
}